import router from '@/router'

// Initial state
const state = {
  title: '',
  sidebarItemKey: null,
  historyBack: null
}

// Mutations
const mutations = {
  setTitle (state, title) {
    state.title = title
  },
  setSidebarItemKey (state, key) {
    state.sidebarItemKey = key
  },
  setHistoryBack (state, historyBack) {
    state.historyBack = historyBack
  }
}

// Actions
const actions = {
  setTitle ({ commit, state }, ctx) {
    commit('setTitle', ctx.title)
  },
  setSidebarItem ({ commit, state }, ctx) {
    commit('setSidebarItemKey', ctx.key)
    commit('setTitle', ctx.text)
  },
  setHistoryBack ({ commit, state }, ctx) {
    commit('setHistoryBack', ctx)
  },
  goBack ({ commit, state }) {
    if (state.historyBack) {
      let historyBack = state.historyBack
      commit('setHistoryBack', null)
      router.push(historyBack)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/page.js